const changeLog = [
  {
    version: "05.11.05",
    issues: [
      {id: "", description: "reset npm packages from last push."}
    ]
  }
];

export default changeLog;
